import { useMemo } from 'react';
import { COMMON_MOBILE_BREAKPOINT, useWindowWidth } from '@elfsight/lib-utils';

export const useIsMobile = () => {
  const windowWidth = useWindowWidth();

  return useMemo(() => windowWidth <= COMMON_MOBILE_BREAKPOINT, [windowWidth]);
};
